import { DocumentLogEntry } from "@stratify/shared";
import {
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../../../config/firebase";

export const subscribeToDocumentLogs = (
  documentId: string,
  onData: (logs: DocumentLogEntry[]) => void,
  onError: (error: Error) => void
): (() => void) => {
  const logsRef = collection(db, "documentLogs");
  const q = query(
    logsRef,
    where("documentId", "==", documentId),
    orderBy("timestamp", "desc")
  );

  return onSnapshot(
    q,
    (snapshot) => {
      const logEntries = snapshot.docs.map((doc) => ({
        ...(doc.data() as DocumentLogEntry),
      }));
      onData(logEntries);
    },
    (err) => {
      console.error("Error fetching logs:", err);
      onError(err);
    }
  );
};
